







import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { Component } from 'vue-property-decorator';

const { mapGetters } = createNamespacedHelpers('spotify');

@Component({
    computed: {
        ...mapGetters([
            'authUrl',
        ]),
    },
})
export default class SpotifyLogin extends Vue {
    'authUrl': string;
}
